module.exports = __webpack_public_path__ + "img/logo.4cb8b932.png";